export const GRID_HISTORY_RESTORED_INCOMPLETE_HALO_STARTED_AT =
  '__gmmRestoredIncompleteHaloStartedAt';

const DEFAULT_HALO_RADIUS = 9;
const HALO_PULSE_MS = 650;
const HALO_REPAINT_MS = 80;

interface GridHistoryRestoredIncompleteHaloObject {
  first?: {
    cx?: number;
    cy?: number;
  };
  second?: unknown;
  [key: string]: unknown;
}

interface GridHistoryRestoredIncompleteHaloPainterOptions {
  color: string;
  paintCanvas: () => void;
}

type GridHistoryRestoredIncompleteHaloPainter = (
  ctx: CanvasRenderingContext2D,
  obj: GridHistoryRestoredIncompleteHaloObject | undefined
) => void;

export const markHistoryRestoredIncompleteShape = (
  obj: GridHistoryRestoredIncompleteHaloObject | undefined
): void => {
  if (!obj) {
    return;
  }

  Object.defineProperty(obj, GRID_HISTORY_RESTORED_INCOMPLETE_HALO_STARTED_AT, {
    configurable: true,
    enumerable: false,
    value: Date.now(),
    writable: true,
  });
};

export const isHistoryRestoredIncompleteHaloProperty = (key: string): boolean =>
  key === GRID_HISTORY_RESTORED_INCOMPLETE_HALO_STARTED_AT;

const getHistoryRestoredIncompleteHaloPulse = (
  obj: GridHistoryRestoredIncompleteHaloObject | undefined
): number | undefined => {
  if (
    !obj ||
    !obj.first ||
    obj.second ||
    !obj[GRID_HISTORY_RESTORED_INCOMPLETE_HALO_STARTED_AT]
  ) {
    return undefined;
  }

  const elapsedMs =
    Date.now() - Number(obj[GRID_HISTORY_RESTORED_INCOMPLETE_HALO_STARTED_AT]);

  return (
    (Math.sin((elapsedMs / HALO_PULSE_MS) * Math.PI * 2 - Math.PI / 2) + 1) / 2
  );
};

export const createGridHistoryRestoredIncompleteHaloPainter = ({
  color,
  paintCanvas,
}: GridHistoryRestoredIncompleteHaloPainterOptions): GridHistoryRestoredIncompleteHaloPainter => {
  let paintRequest: ReturnType<typeof setTimeout> | undefined;

  const schedulePaint = (): void => {
    if (paintRequest) {
      return;
    }

    paintRequest = setTimeout(function () {
      paintRequest = undefined;
      paintCanvas();
    }, HALO_REPAINT_MS);
  };

  return function paintHistoryRestoredIncompleteHalo(
    ctx: CanvasRenderingContext2D,
    obj: GridHistoryRestoredIncompleteHaloObject | undefined
  ): void {
    const first = obj?.first;
    const pulse = getHistoryRestoredIncompleteHaloPulse(obj);

    if (pulse === undefined || !first) {
      return;
    }

    ctx.save();
    ctx.globalAlpha = 0.25 + pulse * 0.2;
    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(
      Number(first.cx),
      Number(first.cy),
      DEFAULT_HALO_RADIUS + pulse * 3,
      0,
      2 * Math.PI
    );
    ctx.stroke();
    ctx.restore();

    schedulePaint();
  };
};
